var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTypography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 14.369141 4.0019531 A 1.50015 1.50015 0 0 0 13.054688 4.9492188 L 5.5332031 24 L 5 24 A 1.0001 1.0001 0 1 0 5 26 L 9 26 A 1.0001 1.0001 0 1 0 9 24 L 8.7578125 24 L 10.339844 19.990234 A 1.0001 1.0001 0 0 0 10.5 20 L 19.347656 20 L 21.152344 24 L 21 24 A 1.0001 1.0001 0 1 0 21 26 L 25 26 A 1.0001 1.0001 0 1 0 25 24 L 24.445312 24 L 15.816406 4.8828125 A 1.50015 1.50015 0 0 0 14.369141 4.0019531 z M 14.541016 9.3515625 L 18.445312 18 L 11.126953 18 L 14.541016 9.3515625 z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTypography);
export default __webpack_public_path__ + "static/media/icons-typography.4901217c66aa5d0b84f888c8cf6d194b.svg";
export { ForwardRef as ReactComponent };